module.exports = __webpack_public_path__ + "img/logo1.984a1e60.png";